import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import VerticalAZCatalog from '../People/VerticalAZCatalog';
import PersonIdentityTab from '../People/PersonIdentityTab';
import AppAccountTab from '../People/AppAccountTab';
import { peopleService } from '../../services/api';

export default function IdentityAccessAdminPage(){
  const [letter, setLetter] = React.useState(null);
  const [selected, setSelected] = React.useState(null);


  const handleSelect = (p) => {
    setSelected(p ? { Id: p.Id ?? p.id, FullName: p.FullName || p.fullName, ...p } : null);
  };
  const [summary, setSummary] = React.useState(null);
  React.useEffect(()=>{
    let active = true;
    (async ()=>{
      if(!selected?.Id){ setSummary(null); return; }
      const s = await peopleService.getProfileSummary(selected.Id);
      if(active) setSummary(s);
    })();
    return ()=>{ active=false };
  }, [selected?.Id]);


  return (
    <Box sx={{ p:2, display:'grid', gridTemplateColumns:{ xs:'1fr', md:'300px 1fr' }, gap:1 }}>
      {/* Left: Catalog (same frame as Logging) */}
      <Box sx={{ minWidth:0, position:'relative', zIndex:0, overflow:'hidden' }}>
        <Paper sx={{ p:1.5, mb:1.5, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <Typography variant="subtitle1">Identity & Access</Typography>
        </Paper>
        <VerticalAZCatalog letter={letter} onLetterChange={setLetter} selectedId={selected?.Id} onSelect={handleSelect} collapsed={false} />
      </Box>

      {/* Right: Panels */}
      <Paper sx={{ p:1.5, minHeight: 400, overflow:'hidden' }}>
        {selected ? (
          <>
            <Typography variant="h6" sx={{ mb:1 }}>{selected.FullName || selected.fullName}</Typography>
            <Typography variant="subtitle2" sx={{ mb:1 }}>Identity</Typography>
            <PersonIdentityTab person={selected} summary={summary} onChanged={()=> peopleService.invalidateProfileSummary(selected.Id)} />
            <Box sx={{ my:2 }} />
            <Typography variant="subtitle2" sx={{ mb:1 }}>App User</Typography>
            <AppAccountTab person={selected} summary={summary} />
          </>
        ) : (
          <Box sx={{ color:'text.secondary' }}>Select a person from the catalog...</Box>
        )}
      </Paper>


    </Box>
  );
}

